import { Link, useParams } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/feature/Seo";
import MediaDetail from "./components/MediaDetail";
import NewsDetail from "./components/NewsDetail";
import { getMediaById, getNewsById, getRelatedMedia } from "@/lib/catalog";

export default function DetailPage() {
  const { id } = useParams();
  const media = id ? getMediaById(id) : undefined;
  const news = id ? getNewsById(id) : undefined;

  if (!media && !news) {
    return (
      <SiteLayout>
        <Seo title="内容不存在 - 唐心" description="抱歉，未找到对应的影视内容。" />
        <div className="w-full px-4 md:px-6 py-20">
          <div className="flex flex-col items-center justify-center rounded-lg bg-background-100 py-20 ring-1 ring-background-200">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-3xl text-foreground-400">
              <i className="ri-emotion-sad-line"></i>
            </span>
            <p className="mt-4 text-lg font-medium text-foreground-800">
              没有找到对应的影视内容
            </p>
            <p className="mt-1 text-sm text-foreground-500">
              该内容可能已下架或链接有误
            </p>
            <Link
              to="/"
              className="mt-6 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-700 transition-colors cursor-pointer"
            >
              返回首页
            </Link>
          </div>
        </div>
      </SiteLayout>
    );
  }

  const categoryName = media ? media.type : "资讯";
  const title = media ? media.title : news!.title;
  const isMedia = Boolean(media);

  const seoTitle = isMedia
    ? `${title}详情介绍 - 唐心`
    : `${title} - 唐心影视资讯`;
  const seoDesc = isMedia
    ? `${media!.synopsis} 类型：${media!.genres.join("、")}，${media!.year} 年${media!.type}，导演${media!.director}。`
    : news!.summary;
  const seoKeywords = isMedia
    ? `唐心,${title},${media!.type},${media!.genres.join(",")},剧情介绍`
    : `唐心,影视资讯,${news!.tag},${title}`;

  return (
    <SiteLayout>
      <Seo
        title={seoTitle}
        description={seoDesc}
        keywords={seoKeywords}
        canonicalPath={`/detail/${id}`}
      />

      <div className="w-full px-4 md:px-6 pt-6 pb-1">
        <nav className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-400">
          <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">
            首页
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <Link
            to={`/category/${categoryName}`}
            className="hover:text-primary-600 transition-colors cursor-pointer"
          >
            {categoryName}
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-600 line-clamp-1">{title}</span>
        </nav>
      </div>

      {media ? (
        <div className="-mt-1">
          <MediaDetail item={media} related={getRelatedMedia(media, 4)} />
        </div>
      ) : (
        <NewsDetail item={news!} />
      )}
    </SiteLayout>
  );
}